import {moment, split, createSelector} from 'vendor';
import {date} from 'store/common';
import {monthDetailed} from './month';
import {status} from 'store/activities/selectors/status';

export const matchesRepetition = createSelector(
  [ date, monthDetailed ],
  ( date, monthDetailed ) => activity => {
    const { repeatType, scheduleDate, repeatDays, repeatCount, months, ts } = activity;

    if (/future|expired/i.test(status(activity, date.unix()))) {
      return false;
    }

    switch (repeatType) {
      case 'PerDay':
        return matchesWeekdays(date, repeatDays);

      case 'PerWeek':
        return true;

      case 'Monthly':
        if (repeatCount > 1) {
          const everyOtherMonth = repeatCount;
          const startMonth = moment.unix(scheduleDate);
          if (date.diff(startMonth, 'months') % everyOtherMonth != 0) {
            return false;
          }
        }
        return split(repeatDays, ',').indexOf(date.date()+'') != -1;

      case 'PeriodDays':
        const differenceInDays = date.diff(moment.unix(scheduleDate), 'days');
        return differenceInDays % repeatCount == 0;

      case 'Weekly':
      case 'Weekly_Specific':
        if (/^(day|weekday|weekend_day)$/.test(repeatDays)) {
          return monthDetailed.matchesRepeatDays(date, activity);
        }
        if (repeatType == 'Weekly' && date.diff(moment.unix(scheduleDate), 'weeks') % repeatCount) {
          return false;
        }
        if (repeatType == 'Weekly_Specific' && monthDetailed.getOccurrence(date) != repeatCount) {
          return false;
        }
        return matchesWeekdays(date, repeatDays);

      case 'Yearly':
        if (split(months, ',').indexOf(date.month() + 1 + '') == -1) {
          return false;
        }
        if (/^(day|weekday|weekend_day)$/.test(repeatDays)) {
          return monthDetailed.matchesRepeatDays(date, activity);
        } else if (repeatDays) {
          return monthDetailed.getOccurrence(date) == repeatCount && matchesWeekdays(date, repeatDays);
        }
        return moment.unix(scheduleDate).date() == date.date();

      default:
        if (ts) {
          return ts == date.unix();
        }
    }
},
  { memoizeOptions: { maxSize: 100 } },
);

function matchesWeekdays(date, days) {
  return days && ''.concat(days).indexOf(date.isoWeekday()) != -1;
}
